import { render, staticRenderFns } from "./PerformedWorkList.vue?vue&type=template&id=27201fa9&scoped=true&"
import script from "./PerformedWorkList.vue?vue&type=script&lang=ts&"
export * from "./PerformedWorkList.vue?vue&type=script&lang=ts&"
import style0 from "./PerformedWorkList.vue?vue&type=style&index=0&id=27201fa9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27201fa9",
  null
  
)

/* custom blocks */
import block0 from "./PerformedWorkList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports